import { render } from "./Home.svg?vue&type=template&id=e8c103e2"
const script = {}
script.render = render

export default script